import React from 'react';

import DashboardComponent from 'components/Dashboard';

const Dashboard: React.FC = () => <DashboardComponent />;

export default Dashboard;
